import { FC } from 'react';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import styles from './FormatAmount.module.scss';

interface FormatAmountTypes {
  amount: string;
  compact?: boolean;
  stylePadding?: boolean;
}

export const FormatAmount: FC<FormatAmountTypes> = ({
  amount,
  compact = false,
  stylePadding,
}) => {
  const formatted = addSpaceNumber(amount);

  const splitted = formatted.split(',');

  const [head, decimal] = splitted;

  if (amount === null) {
    return (
      <div className={styles.item} style={compact ? { padding: '12px 8px' } : {}}>
        -<div className={styles.item_decimal}></div>
      </div>
    );
  }

  if (decimal) {
    return (
      <div className={styles.item} style={compact ? { padding: '12px 8px' } : {}}>
        {head}
        <div className={styles.item_decimal}>,{decimal}</div>
      </div>
    );
  }

  return (
    <div
      className={styles.item}
      style={compact ? { padding: stylePadding ? '12px 8px' : 0 } : {}}>
      {head}
      <div className={styles.item_decimal}>,00</div>
    </div>
  );
};
